import cloudinary from 'cloudinary-core';
import WebFont from 'webfontloader';
import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init({
  once: true,
  easing: 'ease-in-out'
});

const cl = cloudinary.Cloudinary.new({ cloud_name: 'joshkennedy' });
cl.responsive();

WebFont.load({
  google: { families: ['Cabin:400,700'] },
  custom: { families: ['Butler'] }
});
